import * as fb from "@/firebase";
import * as utils from "@/utils";
import _ from "lodash";

export async function getUser(opts) {
  let omitKeys = [];

  let { userId, email } = opts;
  let res;
  if (userId) {
    res = fb.usersCollection.doc(userId);
    res = await res.get();
    res = res.data();
  } else if (email) {
    res = fb.usersCollection.where("email", "==", email);
    res = await res.get();
    res = utils.convertToArray(res);
    res = res[0];
  }
  res = _.omit(res, omitKeys);
  return res;
}

export async function getEntity(opts) {
  let omitKeys = [];

  let { entityId } = opts;
  let res;
  res = fb.entityCollection.doc(entityId);
  res = await res.get();
  let d = res.data() || {};
  res = _.omit(d, omitKeys);
  return d;
}

export async function writeEntity(opts) {
  let { entityId, newEntityState } = opts;
  let res;
  let ref = fb.entityCollection.doc(entityId);
  res = await ref.set(newEntityState, { merge: true });
  res = await getEntity({ entityId });
  return res;
}

export async function delEntity(opts) {
  let { entityId } = opts;
  let res;
  res = fb.entityCollection.doc(entityId);
  res = await res.delete();
  return res;
}
